<div class="setting-page">
  <legend>Short Calls Profiles</legend>
  <div class="action-buttons">
    <arm-action-bar (addClick)="addShortCallsProfile()" [disableAdd]="isUnauthorized"
                    (refreshClick)="refresh()"
                    (deleteClick)="deleteShortCallsProfile()" [disableDelete]="isUnauthorized || !selection"
                    (editClick)="editShortCallsProfile()" [disableEdit]="isUnauthorized || !selection">
    </arm-action-bar>
  </div>
  <div class="short-call-table">
    <arm-table [displayedColumns]="displayedColumns"
               (onSelection)="onSelection($event)" (pageChanged)="pageChanged($event)"
               [data]="data.elements" [length]="data.totalElements"
               [isMultipleSelection]="false"
               [isClientSide]="false"></arm-table>
  </div>
</div>
